<template class="height100">
  <div id="standard-funnel" v-if="loaded">
    <FunnelContainer>
      <router-view/>
    </FunnelContainer>
  </div>
</template>

<script>
import FunnelContainer from './components/FunnelContainer';

export default {
  name: 'App',
  components: {
    FunnelContainer
  },
  data() {
    return {
      loaded: this.$store
    }
  },
  created() {
    this.$store.dispatch('getQuestionList');
  }
}
</script>

<style lang="less">
  @import url('../../assets/funnel/styles.less');
</style>
